import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnDestroy,
	OnInit,
	Output,
} from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import FilterList, { FilterValues, OptionsFilter } from 'projects/access-control/src/app/Domain/Entities/filter-list.interface';
import { TranslateService } from '@mangosoft/mango-layout';
import { Subscription } from 'rxjs';

type actions = 'refresh' | 'add' | 'search' | 'delete';
interface LayoutTableTranslate {
	buttonSearch: string;
	buttonRefresh: string;
	buttonDelete: string;
	buttonAdd: string;
	clear: string;
	search: string;
}
@Component({
	selector: 'layout-table',
	templateUrl: './layout-table.component.html',
	styleUrls: ['./layout-table.component.scss'],
})
export class LayoutTableComponent implements OnInit, OnDestroy {
	@Input() public isDisabledSearch: boolean = false;
	@Input() public isDisabledRefresh: boolean = false;
	@Input() public isAdd: boolean = false;
	@Input() public viewDelete: boolean = true;
	@Input() public filterList: FilterList[] = [];
	@Input() public optionsFilter: OptionsFilter[] = [];
	@Input() public widthFilter: number = 414;
	@Input() public heigth = 0;
	@Input() private customForm!: FormGroup;
	@Output() private action = new EventEmitter<actions>();
	@Output() private isLoading = new EventEmitter<boolean>();
	@Output() private filterValues = new EventEmitter<FilterValues[]>();
	@Output() private filterSelected = new EventEmitter<OptionsFilter[]>();

	data = '';
	placeholder = 'Search';
	public showSearch: boolean = false;
	public filterForm: FormGroup = this.formBuilder.group({});
	subscriptionTranslate!: Subscription;
	dataTranslate: LayoutTableTranslate = {} as LayoutTableTranslate;
	public isRefresh: boolean = false;
	mobile = 0;
	constructor(private formBuilder: FormBuilder, private translateService: TranslateService) {}

	ngOnInit(): void {
		if (this.customForm) {
			this.filterForm = this.customForm;
		} else {
			this.generateForm();
		}
		this.getTranslate();
	}

	public onClickAction(action: actions) {
		this.action.emit(action);
		if (action === 'refresh') {
			this.refreshButton();
		}
	}
	getTranslate() {
		this.subscriptionTranslate = this.translateService.init('AccessControl').subscribe((data) => {
			this.dataTranslate = data.components.table;
		});
	}
	public onClickSearch() {
		this.showSearch = !this.showSearch;
	}

	private generateForm() {
		this.filterList.forEach((filter) => {
			this.filterForm.addControl(
				filter.key,
				this.formBuilder.control(filter.value, filter.validators)
			);
		});
	}

	public onSubmit(filterForm: FormGroup) {
		const filterValues: FilterValues[] = [];
		this.filterList.forEach((filter) => {
			const value = filterForm.get(filter.key)?.value;
			if (value) {
				filterValues.push({
					key: filter.key,
					value: value,
					type: filter.type,
				});
			}
		});
		this.filterValues.emit(filterValues);
	}

	public onClearForm() {
		this.filterForm.reset();
		this.filterValues.emit([]);
	}

	filterSelectedValue(options: OptionsFilter[]) {
		this.filterSelected.emit(options);
	}

	private refreshButton() {
		if (!this.isRefresh) {
			this.isRefresh = true;
			this.isDisabledRefresh = true;
			this.isLoading.emit(true);
			const promise = new Promise<void>((resolve) => {
				setTimeout(() => {
					resolve();
				}, 3000);
			});
			promise.then(() => {
				this.isDisabledRefresh = false;
				this.isRefresh = false;
				// this.isLoading.emit(false);
			});
		}
	}

	@HostListener('window:resize', ['$event'])
	onResize() {
		if (window.innerWidth > 767) {
			this.mobile = 0;
		}

		if (window.innerWidth < 768) {
			this.mobile = 44;
		}
	}
	calcHeigthTable(value = 0) {
		return {
			height: `calc(100vh - ${this.showSearch ? value + this.mobile + 46 : value}px)`,
		};
	}
	ngOnDestroy(): void {
		this.subscriptionTranslate?.unsubscribe();
	}
}
